import { render, staticRenderFns } from "./MaidQuoteList.vue?vue&type=template&id=08525816&"
import script from "./MaidQuoteList.vue?vue&type=script&lang=js&"
export * from "./MaidQuoteList.vue?vue&type=script&lang=js&"
import style0 from "./MaidQuoteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidQuoteList.vue"
export default component.exports